import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
gsap.registerPlugin(ScrollTrigger);
import { IS_SP } from '~/const/config';


export class MaskImage {
  constructor() {
    this.DOM = {};
    this.DOM.tvScene = document.querySelector('.js-tvScene');
    this.DOM.tvSceneImage = document.querySelector('.js-tvSceneImage');
    this.DOM.interviewScene = document.querySelector('.js-interviewScene');
    this.DOM.interviewSceneImage = document.querySelector('.js-interviewSceneImage');

    this.onInit();
  }
  /**
   * 初期化
   */
  onInit() {
    this._setScrollTrigger();
  }
  /**
   * スクロールトリガーのセット
   */
  _setScrollTrigger() {

    // 丸形の窓が広がっていく
    gsap.fromTo( this.DOM.tvScene, {
        maskSize: '5%',
      },{
        maskSize: (IS_SP) ? '140%' : '120%',
        scrollTrigger: {
          trigger: this.DOM.tvScene,
          start: (IS_SP) ? 'top-=80% top' : 'top-=50% top',
          end: `top top`, 
          fastScrollEnd: true,
          scrub: 0.5,
        }
      }
    );
    gsap.fromTo(this.DOM.tvSceneImage, {
        scale: '1.3',
      }, {
        scale: '1',
        scrollTrigger: {
          trigger: this.DOM.tvScene,
          start: 'top-=60% top',
          end: `top top`, // 固定より早く終わる
          fastScrollEnd: true,
          scrub: 0.2,
        }
      }
    );

    // 四角の窓が広がっていく
    gsap.fromTo( this.DOM.interviewScene, {
        maskSize: '0%',
      },{
        maskSize: '130%',
        scrollTrigger: {
          trigger: this.DOM.interviewScene,
          start: (IS_SP) ? 'top-=100% top' : 'top-=50% top',
          end: `top top`, 
          fastScrollEnd: true,
          scrub: 0.5,
        }
      }
    );
    gsap.fromTo(this.DOM.interviewSceneImage , {
        scale: '1.3',
      }, {
        scale: '1',
        scrollTrigger: {
          trigger: this.DOM.interviewScene,
          start: 'top-=60% top',
          end: `top top`, // 固定より早く終わる
          fastScrollEnd: true,
          scrub: 0.2,
        }
      }
    );

  }
}
